import React from 'react'
import { RegisterFormInfoTypes } from '../../helpers/enums'
import { TEducationalInfo, TProfessionalInfo } from '../../hooks/useFormRegister'
import CustomOutput from '../../components/TextOutput'

interface Props<T> {
    title: string
    infoArray: T[]
    type: RegisterFormInfoTypes.Educational | RegisterFormInfoTypes.Professional
}

function PendingUserFormList<T extends TProfessionalInfo | TEducationalInfo>({
    type,
    title,
    infoArray,
}: Props<T>) {
    return (
        <div>
            {infoArray.length > 0 && (
                <>
                    <span className="md:mt-4 text-base md:text-xl">{title}</span>
                    {infoArray.map((info) => (
                        <div
                            key={`${type}${info.id}`}
                            className="gap-2 md:gap-6 mt-1 md:mt-3 items-center"
                        >
                            <CustomOutput
                                key={info.id}
                                primaryText={
                                    ((info as TProfessionalInfo).companyName as string) ??
                                    ((info as TEducationalInfo).school as string)
                                }
                                secondaryText={`${info.startDate} - ${info.endingDate !== '' ? info.endingDate : 'Actualidad'}`}
                                className="w-full pointer-events-none"
                            />
                        </div>
                    ))}
                </>
            )}
        </div>
    )
}

export default PendingUserFormList
